<div class="login-container">
  <button
    mat-icon-button
    type="button"
    class="theme-toggle"
    [attr.aria-label]="(isDarkMode$ | async) === 'dark' ? 'Enable light mode' : 'Enable dark mode'"
    (click)="toggleTheme()">
    <mat-icon>{{ (isDarkMode$ | async) === 'dark' ? 'light_mode' : 'dark_mode' }}</mat-icon>
  </button>
  <mat-card class="login-card">
    <div class="login-branding">
      <img
        [src]="(isDarkMode$ | async) === 'dark'
          ? 'assets/tbds-commong-logo-full-dark.png'
          : 'assets/tbds-commong-logo-full-light.png'"
        alt="The Big Data Showroom"
        class="login-logo" />
    </div>
    <mat-card-header>
      <mat-card-subtitle>Login to continue</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <div *ngIf="maintenanceModeActive" class="maintenance-notice" role="status" aria-live="polite">
        <mat-icon>build_circle</mat-icon>
        <div>
          <strong>Scheduled maintenance</strong>
          <p>{{ maintenanceMessage }}</p>
        </div>
      </div>
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" autocomplete="on" method="post" action=".">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Email</mat-label>
          <input
            matInput
            type="email"
            formControlName="email"
            id="login-email"
            name="email"
            autocomplete="username"
            autocapitalize="none"
            spellcheck="false"
            [disabled]="maintenanceModeActive"
            required>
          <mat-error *ngIf="loginForm.get('email')?.hasError('required')">
            Email is required
          </mat-error>
          <mat-error *ngIf="loginForm.get('email')?.hasError('email')">
            Invalid email format
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Password</mat-label>
          <input
            matInput
            type="password"
            formControlName="password"
            id="login-password"
            name="password"
            autocomplete="current-password"
            [disabled]="maintenanceModeActive"
            required>
          <mat-error *ngIf="loginForm.get('password')?.hasError('required')">
            Password is required
          </mat-error>
        </mat-form-field>

        <button
          mat-raised-button
          color="primary"
          type="submit"
          class="full-width"
          [disabled]="maintenanceModeActive || !loginForm.valid || loading">
          <mat-spinner diameter="20" *ngIf="loading" style="display: inline-block; margin-right: 8px;"></mat-spinner>
          {{ loading ? 'Logging in...' : 'Login' }}
        </button>

        <button
          mat-button
          type="button"
          class="forgot-password-link"
          (click)="goToForgotPassword()"
          [disabled]="maintenanceModeActive">
          I forgot my password
        </button>
      </form>
    </mat-card-content>
  </mat-card>
</div>


